import { render, staticRenderFns } from "./BindOtherWechatPopup.vue?vue&type=template&id=72070ff8&scoped=true"
import script from "./BindOtherWechatPopup.vue?vue&type=script&lang=ts"
export * from "./BindOtherWechatPopup.vue?vue&type=script&lang=ts"
import style0 from "./BindOtherWechatPopup.vue?vue&type=style&index=0&id=72070ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72070ff8",
  null
  
)

export default component.exports